export enum NotificationRefTypeEnum {
  DANCE_CLASS = 'DANCE_CLASS',
  ROOM_RENTAL_ORDER = 'ROOM_RENTAL_ORDER'
}
